import debounce from './debounce'

function prepareSearch () {
  let fbEventTracked = false
  let controller
  let signal
  const url = '/search/live'

  function closeSearch () {
    document.getElementById('liveResultsContainer').innerHTML = ''
  }

  const input = document.querySelector('.search-query')

  if (!input) {
    return
  }

  const performSearch = debounce((term) => {
    controller = new AbortController()
    signal = controller.signal
    if (!fbEventTracked && typeof window.fbq === 'function') {
      fbEventTracked = true
      window.fbq('track', 'Search', { search_string: term })
    }
    fetch(`${url}?term=${term}`, { signal })
      .then((response) => response.text())
      .then((html) => {
        const liveResultsContainer = document.getElementById('liveResultsContainer')
        liveResultsContainer.innerHTML = html
        const close = liveResultsContainer.querySelector('.close')
        if (close) {
          close.addEventListener('click', closeSearch)
        }
      })
      // This error is not fully handled in development environment with rack-mini-profiler.
      // It will show up on a browser console as an Uncaught (in promise) error despite being caught here.
      // In production it is sufficiently by this catch block.
      .catch((error) => {
        // AbortError is expected when the user types more while a request is in progress.
        if (error.name !== 'AbortError') {
          throw error
        }
      })
  }, 750)

  input.addEventListener('keyup', function handleKeyup (e) {
    const term = this.value

    if (e.key === 'Escape' || term.length < 3) {
      closeSearch()
      return
    }

    if (typeof signal !== 'undefined' && !signal.aborted) {
      controller.abort()
      signal = undefined
    }

    performSearch(term)
  })

  document.addEventListener('click', (e) => {
    if (e.target.matches('#liveResults .close')) {
      closeSearch()
      e.preventDefault()
    }

    if (e.target.matches('#liveSearchSubmit')) {
      e.preventDefault()
      closeSearch()
      document.getElementById('search-form').submit()
    }
  })
}

export default prepareSearch
